import { responsive } from '../../util';
import { TPalette } from './types';

const actions = { dark: '#cce5ff', light: '#557' };
const spacingArray = Array(50)
  .fill(1)
  .map((_, i) => {
    return responsive<number>({
      0: Math.ceil(i / 2.5),
      1: Math.ceil(i / 2.1),
      2: Math.ceil(i / 1.7),
      3: Math.ceil(i / 1.3),
      4: i,
    });
  });

const defaultPalette: TPalette = {
  action: {
    disabled: '#d9d9d9',
    disabledOpacity: 1,
    active: actions,
    activeOpacity: 0.45,
    focus: actions,
    focusOpacity: 0.05,
    hover: actions,
    hoverOpacity: 0.1,
    readonly: actions,
    readonlyOpacity: 0.4,
    selected: 'rgb(204 214 222)',
    selectedOpacity: 1,
  },
  background: {
    default: '#f4f4f4',
    overlay: 'rgba(0, 0, 0, 0.2)',
    paper: 'white',
  },
  border: {
    article: '#cacaca',
    field: '#444',
    ghost: '#f5f5f5',
    section: '#aaa',
  },
  common: {
    black: 'black',
    white: 'white',
  },
  info: {
    main: '#fff',
  },
  primary: {
    main: '#00496c',
  },
  secondary: {
    light: '#fcfcfc',
    main: '#6c757d',
  },
  spacing: (index: number) => {
    return spacingArray[index];
  },
  text: {
    accent: '#609',
    disabled: '#555',
    icon: 'white',
    link: '#00496c',
    primary: '#4a4a4a',
    secondary: 'white',
    title: '#00496c',
  },
  error: {
    main: 'rgb(187,12,15)',
    light: '#fff2f4',
  },
  success: {
    main: '#8bde8b',
    light: '#e7ffd9',
  },
  warning: {
    main: '#f8f588',
    light: '#fffdd9',
  },
  darkenRatio: 15,
  lightenRatio: 35,
  responsive,
  queryColumnsMultiplier: 2,
};
export default defaultPalette;
